export const ConfidentialityRating = {
  LOW: 'LOW',
  MEDIUM: 'MEDIUM',
  HIGH: 'HIGH',
  CRITICAL: 'CRITICAL',
}

export type ConfidentialityRating = keyof typeof ConfidentialityRating

export const IntegrityRating = {
  LOW: 'LOW',
  MEDIUM: 'MEDIUM',
  HIGH: 'HIGH',
  CRITICAL: 'CRITICAL',
}

export type IntegrityRating = keyof typeof IntegrityRating

export const AvailabilityRating = {
  LOW: 'LOW',
  MEDIUM: 'MEDIUM',
  HIGH: 'HIGH',
  CRITICAL: 'CRITICAL',
}

export type AvailabilityRating = keyof typeof AvailabilityRating

export const BusinessImpactLevel = {
  LOW: 'LOW',
  MEDIUM: 'MEDIUM',
  HIGH: 'HIGH',
  CRITICAL: 'CRITICAL',
}

export type BusinessImpactLevel = keyof typeof BusinessImpactLevel

export const AssetStatus = {
  ACTIVE: 'ACTIVE',
  INACTIVE: 'INACTIVE',
  UNDER_MAINTENANCE: 'UNDER_MAINTENANCE',
  RETIRED: 'RETIRED',
}

export type AssetStatus = keyof typeof AssetStatus
